// Shared live-stats hook — pulls /api/declaration/stats every 60s so any
// component on the site can render DB-driven signature + country counts
// without hardcoding numbers like "150+ Countries".
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useLiveStats(refreshMs = 60000) {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const fetchStats = () => {
      axios.get(`${API}/declaration/stats`).then((r) => {
        if (!cancelled) setStats(r.data || null);
      }).catch(() => { /* silent */ });
    };
    fetchStats();
    const t = setInterval(fetchStats, refreshMs);
    return () => { cancelled = true; clearInterval(t); };
  }, [refreshMs]);
  return stats;
}
